export default "__VITE_ASSET__CHhE54TY__"